import React from 'react';
import { FaGithub, FaFacebookF, FaLinkedinIn, FaTwitter} from 'react-icons/fa';
import { SiLeetcode, SiCodechef } from 'react-icons/si'

const HeaderSocials = () => {
    return (
        <div className='home__socials'>
            <a href='#home' className='home__social-link' target='_blank' rel='noreferrer'>
            </a>

            <a href='https://github.com/Arun-21BEECE006' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaGithub />
            </a>

            <a href="https://leetcode.com/u/user0698K" className="home__social-link" target="_blank" rel="noreferrer">
                <SiLeetcode />
            </a>

            <a href="https://www.codechef.com/users/arun29072003" className="home__social-link" target="_blank" rel="noreferrer">
                <SiCodechef />
            </a>
            {/* <a href='https://hashnode.com/@gregsithole' className='home__social-link' target='_blank' rel='noreferrer'>
                <SiHashnode />
            </a>

            <a href='https://dev.to/gregsithole' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaDev />
            </a>  */}

            <a href='https://www.linkedin.com/in/arun-kumar-m-aa3350249/' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaLinkedinIn />
            </a>

            <a href='https://www.facebook.com/profile.php?id=100013098244893' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaFacebookF />
            </a>

            <a href='https://x.com/Master_Arun29' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaTwitter />
            </a>
        </div>
    );
};

export default HeaderSocials;
